
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.86","height":"8.432"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.967 7.179l5.477-5.323 5.5 5.323.289-.174-5.789-5.612-5.786 5.613z","fill":"#006db6","stroke":"#006db6","stroke-width":"2"}})])
          )
        }
      }
    